module.exports = __webpack_public_path__ + "img/space6.0f53eb7e.jpg";